'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
type PresetButtonProps = Omit<ComponentProps<typeof Button>, 'variant'>;

/** Toolbar icon strip button (viewport settings, inspector chrome) */
export const ToolbarIconButton = t0 => {
  const $ = _c(8);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? "icon" : t1;
  let t2;
  if ($[4] !== className || $[5] !== props || $[6] !== size) {
    t2 = <Button variant="transparent" size={size} className={className} {...props} />;
    $[4] = className;
    $[5] = props;
    $[6] = size;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
ToolbarIconButton.displayName = 'ToolbarIconButton';

/** Outliner / tree row icon toggle (lock, visibility) */
export const OutlinerIconButton = t0 => {
  const $ = _c(8);
  let className;
  let pressed;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      pressed,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = pressed;
    $[3] = props;
  } else {
    className = $[1];
    pressed = $[2];
    props = $[3];
  }
  const t1 = pressed ? "on" : "";
  let t2;
  if ($[4] !== className || $[5] !== props || $[6] !== t1) {
    t2 = <Button variant="clear" size="icon" data-state={t1} className={className} {...props} />;
    $[4] = className;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
OutlinerIconButton.displayName = 'OutlinerIconButton';

/** Title bar control — variant and size are fixed */
export type TitleBarPresetButtonProps = PresetButtonProps & {
  pressed?: boolean;
};
export const TitleBarPresetButton = t0 => {
  const $ = _c(10);
  let className;
  let pressed;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      pressed,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = pressed;
    $[3] = props;
  } else {
    className = $[1];
    pressed = $[2];
    props = $[3];
  }
  const t1 = pressed ? "bg-primary text-primary-foreground hover:bg-primary" : "";
  let t2;
  if ($[4] !== className || $[5] !== t1) {
    t2 = cn("titlebarControls", className, t1);
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2) {
    t3 = <Button variant="titleBar" size="titleBar" className={t2} {...props} />;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
TitleBarPresetButton.displayName = 'TitleBarPresetButton';